import router from '@/router'
import { MessageBox, Message } from 'element-ui'
import { Get } from "@/api/axios";
export default function () {
  let setInterval = null;//定时器
  let timeOut = 1000 * 60 * 60 * 2 // 设置超时时间: 10秒钟
  // console.log("开始", new Date().getTime())
  // 初次向sessionStorage存入操作时间
  window.sessionStorage.setItem('lastTime', new Date().getTime())
  // 每次操作页面，更新sessionStorage存入的操作时间
  // window.onload = function () {
  //   window.document.onmousedown = function () {
  //     console.log("开始", new Date().getTime())
  //     window.sessionStorage.setItem('lastTime', new Date().getTime())
  //   }
  // }
  function checkTimeout() {
    if (window.sessionStorage.getItem("timer")) {
      timeOut = window.sessionStorage.getItem("timer")
    }
    let currentTime = new Date().getTime() // 当前时间
    let lastTime = window.sessionStorage.getItem("lastTime")//上次操作的时间
    // 判断是否超时

    if (currentTime - lastTime >= timeOut * 1000) {
      // console.log("结束", new Date().getTime())
      // 清除定时器
      window.clearInterval(setInterval);
      // 清除sessionStorage
      window.sessionStorage.clear('lastTime')
      // 退出登录
      if (!localStorage.getItem("ExitSta")) {
        MessageBox.confirm(
          '当前登录用户会话过期，请重新登录',
          '系统提示',
          {
            showClose: false,
            showCancelButton: false,
            confirmButtonText: '重新登录',
            type: 'warning'
          }
        )
          .then(() => {
            // console.log('退出接口');
            //退出接口
            let url = "/member/cas/logout/" + localStorage.getItem("uuid");
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            let config = {
              authToken: window.sessionStorage.getItem("token")
            }
            if (keys) {
              for (var i = keys.length; i--;)
                document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
            }
            Get(url, {
              redirectUrl: window.location.protocol + "//" + window.location.host + "/personal",
            }, config).then((res) => {
              // console.log(res, 'logout----res');
              if (typeof res == "object") {
                // console.log('系统错误！');
              } else {
                console.log('自动退出');
                localStorage.removeItem("addLoginNameId");
                localStorage.removeItem("time");
                localStorage.removeItem("memberId");
                localStorage.removeItem("addLoginName");
                localStorage.removeItem("loginName");
                localStorage.removeItem("gy");
                localStorage.removeItem("uuid");
                sessionStorage.clear();
                localStorage.setItem("isLogout", "true");
                location.href = res;
              }
            });

          })
          .catch(() => { })
      }

    }
  }
  /* 定时器 间隔2秒检测是否长时间未操作页面 */
  setInterval = window.setInterval(checkTimeout, 2000)
}



// WEBPACK FOOTER //
// ./src/utils/auto_loginout.js